import { IRefreshTable } from '../../../models/interfaces'

export const selectRefreshTable = ({
  refreshTable: refreshState,
}: {
  refreshTable: IRefreshTable
}) => refreshState.refreshTable
